module.exports = require("@adc/instrument");